const AUTOLOGIN_ENDPOINT = process.env.REACT_APP_AUTOLOGIN_ENDPOINT!;
const REGISTER_ENDPOINT = process.env.REACT_APP_REGISTER_ENDPOINT!;
const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL!;
const AUTH_KEY = process.env.REACT_APP_AUTH_KEY!;
const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT!; 

export interface RegisterResult {
  jwt?: string;
  exists?: boolean;
  errorCode?: number;
}

export async function registerUser(
  email: string,
  name: string,
  phone: string
): Promise<RegisterResult | null> {
  const payload = { 
    email, 
    display_name: name, 
    phone, 
    password: `${name}${phone}`,
    AUTH_KEY 
  };

  try {
    const res = await fetch(REGISTER_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const text = await res.text();
    let data: any;
    try {
      data = JSON.parse(text);
    } catch {
      console.error("Non-JSON response — possibly redirect or HTML:", text);
      return null;
    }

    console.log("Registration API response:", data);

    if (res.ok && (data.jwt || data.data?.jwt)) {
      return { jwt: data.jwt || data.data.jwt };
    } else if (data?.code === "email_exists" || data?.data?.errorCode === 38) {
      return { exists: true };
    } else if (data?.data?.errorCode === 24) {
      return { errorCode: 24 };
    } else {
      console.error("Registration failed:", data?.message || text);
      return null;
    }
  } catch (error) {
    console.error("Registration error:", error);
    return null;
  }
}


export function saveJwtForUser(phone: string, jwt: string) {
  localStorage.setItem(`user_jwt_${phone}`, jwt);
  localStorage.setItem("current_wp_phone", phone);
}

export function getJwtForUser(phone?: string) {
  const targetPhone = phone || localStorage.getItem("current_wp_phone");
  if (!targetPhone) return null;
  return localStorage.getItem(`user_jwt_${targetPhone}`);
}



export function autologinWithJWT(jwt: string) {
  const url = `${AUTOLOGIN_ENDPOINT}&JWT=${encodeURIComponent(jwt)}&redirect_to=${encodeURIComponent(REDIRECT_URL)}`;
  window.location.href = url;
}


export async function loginUser(email: string, password: string): Promise<RegisterResult | null> {
  const payload = { email, password, AUTH_KEY };
  try {
    const res = await fetch(LOGIN_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const text = await res.text();
    let data: any;
    try {
      data = JSON.parse(text);
    } catch {
      console.error("Non-JSON response — possibly redirect or HTML:", text);
      return null;
    }

    console.log("Login API response:", data);

    if (res.ok && data.success && data.data?.jwt) {
      return { jwt: data.data.jwt };
    } else {
      console.error("Login failed:", data.message || text);
      return null;
    }
  } catch (error) {
    console.error("Login error:", error);
    return null;
  }
}
